import React, { useEffect, useState } from 'react'
import Label from '../../../../components/label/Label'
import styles from "./AddFunds.styles"
import TextInput from '../../../../components/input/textinput/TextInput'
import Loadable from '../../../../components/loadable/Loadable'
import commonStyles from "../PaymentDrawer.styles"
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setEnteredAmount, setOpenPrepayFundAccessConfirmationModal, setSalesTax, setSelectedPaymentMode } from './AddFundsSlice'
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks'
import { setBillingDetails, setDisableEnterAmountField, setIsCardPayment, setIsPrepaidAndCardTransaction } from '../PaymentDrawerSlice'
import { componentKey as dataLoaderKey } from '../../../loaders/dataloader/DataLoaderSlice'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import Button from '../../../../components/button/Button'
import { addPrepayBalance, getSavedCards, getStripeSavedCards } from './AddFundsSaga'
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown'
import { MINIMUM_PREPAY_THRESHOLD, PAYMENT_BY_CARD_TYPE_OPTIONS, PAYMENT_DRAWER_LOADING_STATES, PAYMENT_DRAWER_MESSAGE_MAP, PAYMENT_MODES, PAYMENT_OPTIONS, PLACE_OF_ORIGIN_FOR_PAYMENT } from '../constants'
import { AddFundsSavedCardsList } from './savedcardslist/AddFundsSavedCardsList'
import { PayByCard } from './paybycard/PayByCard'
import { componentKey as paymentDrawerSlice } from '../PaymentDrawerSlice'
import General from '../../../../../libs/utility/General'
import { ESTIMATED_TAX, SALES_TAX } from '../billdetails/constants'
import { AddressInformationCard } from '../addressinformationcard/AddressInformationCard'
import PrepayAccessConfirmationModal from './prepayaccessconfirmationmodal/PrepayAccessConfirmationModal'
import CardWIconTitleAndButton from '../../../../components/card/CardWIconTitleAndButton/CardWIconTitleAndButton'

const AddFunds = ({ 
    isOpen = false, 
    onCloseCb = () => { }, 
    placeOfOriginforpayment, 
    onChangeSalesTax = () => {},
    onPayNowCb = () => { }
 }) => {

    useGarbageCollector(componentKey);

    const { prepayAmount } = useSelector(state => state[dataLoaderKey]);
    const { selectedPaymentMode, enteredAmount, salesTax, selectedCard, paymentMethodDetails, openPrepayFundAccessConfirmationModal, stripeCardDetails } = useSelector(state => state[componentKey]);

    const { billingDetails, disableEnterAmountField, isCardPayment, loadingState, payNowCbLoadingState, isSubscription, isUsps, isPrepaidAndCardTransaction } = useSelector(state => state[paymentDrawerSlice])
    const { FinalFilingFee, TotalFilingFee } = billingDetails;
    const [estimatedTaxLabel, setEstimatedTaxLabel] = useState(ESTIMATED_TAX)
    const [paymentByCardType, setPaymentByCardType] = useState(PAYMENT_BY_CARD_TYPE_OPTIONS[0].value);

    const dispatch = useDispatch();
    
    useEffect(() => {
        updateEnteredFieldAmount(true)
        dispatch(setBillingDetails({...billingDetails, EstimatedTax: salesTax }))
    }, [salesTax]);


    useEffect(() => {
        dispatch(getSavedCards());
    }, [])

    useEffect(() => {
        if(selectedCard && Object.keys(selectedCard).length > 0) {
            dispatch(getStripeSavedCards(selectedCard))
        }
    }, [selectedCard])

    useEffect(() => {
        if(shouldDisablePrepayPlusCardOption()){
            handlePaymentByCardTypeSelection(PAYMENT_BY_CARD_TYPE_OPTIONS[1])
        }
    }, [prepayAmount]);

    const updateEnteredFieldAmount = (subtractPrepay = false, amount = null) => {
        if(amount){
            dispatch(setEnteredAmount(amount))
        }else{
            if(subtractPrepay){
                dispatch(setEnteredAmount(General.getNumberAmount(((General.getNumberAmount(FinalFilingFee) + General.getNumberAmount(salesTax)) - General.getNumberAmount(prepayAmount)).toFixed(2))))
            }else{
                dispatch(setEnteredAmount(General.getNumberAmount(((General.getNumberAmount(FinalFilingFee) + General.getNumberAmount(salesTax)).toFixed(2)))))
            }
        }
    }

    const handlePaymentByCardTypeSelection = (type) => {
        setPaymentByCardType(type.value);
        dispatch(setIsPrepaidAndCardTransaction(type.value == PAYMENT_BY_CARD_TYPE_OPTIONS[0].value ? true : false))
        updateEnteredFieldAmount((type.value == PAYMENT_BY_CARD_TYPE_OPTIONS[0].value) ? true : false)
    }

    const renderPaymentOptionCards = () => {
        switch (selectedPaymentMode?.value) {
            case PAYMENT_MODES.PAY_BY_ENTERING_CARD_DETAILS:
                return <PayByCard
                    placeOfOriginforpayment={placeOfOriginforpayment}
                    onPayNowCb={onPayNowCb}
                />

            case PAYMENT_MODES.PAY_USING_SELECTED_CARD:
                return <AddFundsSavedCardsList
                    placeOfOriginforpayment={placeOfOriginforpayment}
                    onPayNowCb={onPayNowCb}
                />
        }
    }

    const shouldDisablePrepayPlusCardOption = () => {
        if(General.getNumberAmount(prepayAmount) == 0 || (((General.getNumberAmount(FinalFilingFee) + General.getNumberAmount(salesTax)) - General.getNumberAmount(prepayAmount)).toFixed(2) < MINIMUM_PREPAY_THRESHOLD)){
            return true
        }else{
            return false
        }
    }

    const balanceAfterPayment = Number(prepayAmount) - Number(FinalFilingFee);

    const { GET_SAVED_CARDS_LOADING, STRIPE_SAVED_CARDS_SALES_TAX_LOADING, PAY_NOW_LOADING, ADD_PREPAY_BALANCE_LOADING, PAYMENT_BY_NEW_CARD_LOADING } = PAYMENT_DRAWER_LOADING_STATES;

    const {number : amount, errors : amountErrors  } = General.sanitizeNumberInput({number:enteredAmount,maxLength:20})

    const handleSalesTaxOnChange = (data, addressInformation) => {
        setEstimatedTaxLabel(SALES_TAX);
        dispatch(setSalesTax(data))
        onChangeSalesTax(data, addressInformation);
    }

    const onPrepayFundAccessClick = (showAdminAmount) => {
        switch (selectedPaymentMode?.value) {
            case PAYMENT_MODES.PAY_BY_ENTERING_CARD_DETAILS:
                dispatch(setOpenPrepayFundAccessConfirmationModal(false))
                dispatch(addPrepayBalance({
                    card_id: paymentMethodDetails.id,
                    amount: enteredAmount,
                    placeOfOriginforpayment: PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE,
                    saveCardDetails: false,
                    showAdminAmount,
                    CardNumber: paymentMethodDetails?.card?.last4 || "",
                    CommonCreditCardNumber: paymentMethodDetails?.card?.last4 || "",
                }))
                break;
            case PAYMENT_MODES.PAY_USING_SELECTED_CARD:
                dispatch(setOpenPrepayFundAccessConfirmationModal(false))
                dispatch(addPrepayBalance({
                    card_id: selectedCard?.id || stripeCardDetails?.id || "",
                    amount: enteredAmount,
                    placeOfOriginforpayment: PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE,
                    addressDetails: selectedCard?.billing_details || stripeCardDetails?.billing_details || "",
                    Customer: selectedCard?.customer || stripeCardDetails?.customer,
                    showAdminAmount,
                    CardNumber: selectedCard?.card?.last4 || stripeCardDetails?.card?.last4 || "",
                    CommonCreditCardNumber: selectedCard?.card?.last4 || stripeCardDetails?.card?.last4 || "",
                }))
                break;
            default:
                return
        }
    }

    return (
        <Loadable
            currentState={loadingState.state}
            loadingStates={[GET_SAVED_CARDS_LOADING]}
            isNewLoadable={true}
            messageMap={PAYMENT_DRAWER_MESSAGE_MAP}
            preserveChildMount={true}
        >
            <div>
                {/* Keeping the overlay loader because when processing a payment using the stripe card component, there was an issue. The Stripe card component was remounting, causing the code to break. It's essential that the Stripe card component remains mounted while a payment is in progress. */}
                <Loadable
                    currentState={payNowCbLoadingState.state}
                    loadingStates={[PAY_NOW_LOADING]}
                    messageMap={PAYMENT_DRAWER_MESSAGE_MAP}
                    preserveChildMount={true}
                    isNewLoadable={true}
                >
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[ADD_PREPAY_BALANCE_LOADING, STRIPE_SAVED_CARDS_SALES_TAX_LOADING, PAYMENT_BY_NEW_CARD_LOADING]}
                        messageMap={PAYMENT_DRAWER_MESSAGE_MAP}
                        preserveChildMount={true}
                    >
                        {isCardPayment && <div style={styles.cardPaymentTypeContainer}>
                            {
                                PAYMENT_BY_CARD_TYPE_OPTIONS.map((type, idx) => (
                                <div style={commonStyles.cardContainer} onClick={() => {
                                    if(!shouldDisablePrepayPlusCardOption()){
                                        handlePaymentByCardTypeSelection(type)
                                    }
                                }}>
                                    <CardWIconTitleAndButton
                                        title={type.label}
                                        customStyles={{...styles.individualCardStyle, ...((shouldDisablePrepayPlusCardOption() && paymentByCardType !== type.value) ? styles.disabledCardStyle : {})}}
                                        isHighlighted={paymentByCardType === type.value ? true : false}
                                        justifyContent="center"
                                        headerCustomStyles={styles.cardHeader}
                                    />
                                </div>
                                ))
                            }
                            
                        </div>
                        }
                        
                        <div style={styles.labelsContainer}>
                            {(!isCardPayment || (isCardPayment && isPrepaidAndCardTransaction)) && <Label customStyles={styles.transactionLabel}>Current Prepay Balance : <span style={commonStyles.amount}>${General.getDecimalAmount(prepayAmount)}</span></Label> }

                            {isCardPayment && <>
                                <Label customStyles={styles.transactionLabel}>Total Fee : <span style={commonStyles.amount}>${FinalFilingFee}</span></Label>
                                <Label customStyles={styles.transactionLabel}>{estimatedTaxLabel} : <span style={commonStyles.amount}>${General.getDecimalAmount(salesTax)}</span></Label>
                                <Label customStyles={styles.transactionLabel}>Total Amount to be Paid including {estimatedTaxLabel} : <span style={commonStyles.amount}>${General.getDecimalAmount(General.getNumberAmount(FinalFilingFee) + General.getNumberAmount(salesTax))}</span></Label>
                                {isPrepaidAndCardTransaction && <Label customStyles={styles.transactionLabel}>Prepay Balance after this Submission : <span style={commonStyles.amount}>${balanceAfterPayment >= 0 ? General.getDecimalAmount(balanceAfterPayment) : 0}</span></Label>}
                                <Label customStyles={styles.transactionLabel}>Amount to be paid by card : <span style={commonStyles.amount}>${enteredAmount}</span></Label></>}
                        </div>

                        <div style={styles.amountBox}>
                            <TextInput
                                name='amount'
                                label={disableEnterAmountField ? "Bill Amount" : "Enter Amount"}
                                placeHolder='Enter an Amount'
                                type='text'
                                value={amount || ""}
                                disabled={disableEnterAmountField}
                                onChangeCb={(e) => {
                                    if (!disableEnterAmountField) {
                                        dispatch(setEnteredAmount(e.target.value))
                                    }
                                }}
                                errors={amountErrors}
                            />
                        </div>

                        <div style={{marginTop: '20px'}}>
                            <AddressInformationCard
                                isSubscription={isSubscription}
                                isUsps={isUsps}
                                showCalculateSalesTax={isCardPayment}
                                uspsAmount={Number(0)}
                                totalAmount={Number((Number(TotalFilingFee)).toFixed(2))}
                                salesTaxSuccessCb={handleSalesTaxOnChange}
                            />
                        </div>

                        <div style={{ marginTop: "20px" }}>
                            <SelectDropdown
                                label="Select the Payment Option"
                                name="selectedPaymentMode"
                                value={selectedPaymentMode}
                                onSelectCb={(name, selectedOption) => dispatch(setSelectedPaymentMode(selectedOption))}
                                options={PAYMENT_OPTIONS}
                                isClearable={false}
                            />
                        </div>

                        {renderPaymentOptionCards()}

                    </Loadable>
                </Loadable>
                
                {
                    isCardPayment &&
                    <div style={styles.alternatePaymentOptions}>
                        <Button
                            type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                            onClickCb={() => {
                                dispatch(setIsCardPayment(false))
                                dispatch(setDisableEnterAmountField(false))
                            }
                            }
                            style={styles.linkBtn}
 
                        >
                            Add Prepay Balance
                        </Button>
                    </div>
                }
                
                {
                    !isCardPayment && FinalFilingFee &&
                    <div style={styles.alternatePaymentOptions}>
                        <Button
                            type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                            onClickCb={() => {
                                dispatch(setIsCardPayment(true))
                                dispatch(setDisableEnterAmountField(true))
                                updateEnteredFieldAmount(General.getNumberAmount(prepayAmount) == 0 ? false : true)
                                setPaymentByCardType(PAYMENT_BY_CARD_TYPE_OPTIONS[isPrepaidAndCardTransaction ? 0 : 1].value)
                            }
                            }
                            style={styles.linkBtn}
 
                        >
                            Pay by card
                        </Button>
                    </div>
                }
                
            </div>
            {openPrepayFundAccessConfirmationModal ? <PrepayAccessConfirmationModal onCloseCb={() => dispatch(setOpenPrepayFundAccessConfirmationModal(false))} onSubmitCb={() => onPrepayFundAccessClick("true")} onCancelCb={() => onPrepayFundAccessClick("false")} isOpen={openPrepayFundAccessConfirmationModal} /> : null}
        </Loadable>
    )
}

export default AddFunds